/** Accessible titles of the article videos (the <video> title + aria-label). EN is the source; the RU twin is generated
 * by docs/marketing/tools/gen-ru-gemini.mjs --kind i18n — never hand-written. */
export const videoTitles = {
  cbtHomeworkOverview: 'Video: how CopingCard homework works, from assigning it to seeing it done',
};
